/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-05-20 10:34:56
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-12-22 14:56:01
 * @FilePath: \MPC-monorepo\features\mpc-common\src\utils\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Decimal from 'decimal.js';
import { isEqual, omit, transform, isObject } from 'lodash';

export { default as ajax } from './ajax';
export { default as axios } from './axios';
export { default as scout } from './scout';
export * from './MPCJsonLogic';
export * from './router';
export * from './versionMonitor';
export * from './sType';
export * from './v1Router';
export { default as showAlertDebounce } from './showAlert';
export * from './scrollUtils';
export * from './sort';
export * from './number';
export { default as withFunctionCall } from './withFunctionCall';
export * from './vendorStorage';

export const defaultRootFontSize = 1;

/**
 * 将nember转换为xxrem，其他类型不做处理
 * @param px
 * @returns
 */
export const localPx2rem = (px?: number | string) => {
  // 如果传入的不是数字，则不做处理
  if (typeof px === 'number' && !isNaN(px))
    return px / defaultRootFontSize + 'rem';
  return px;
};

export const tableColumnWidthToRem = (item: { width?: number | string }) => {
  if (typeof item?.width === 'number') {
    item.width = localPx2rem(item.width);
  }
  return item;
};

export const tableColumnWidthViewBase = (item: { width?: number | string }, viewBase: number = 1) => {
  if (typeof item?.width === 'number') {
    item.width = new Decimal(item.width).mul(viewBase).toNumber();
  }
  return item;
};

export const stylePx2Rem = (item: { width?: number | string }) => {
  if (typeof item?.width === 'number') {
    item.width = localPx2rem(item.width);
  }
  return item;
};

export const getRootElementFontSize = () => {
  const fontSize = document.documentElement.style.fontSize;
  if (fontSize === undefined || fontSize === '') {
    return defaultRootFontSize;
  }
  if (fontSize.indexOf('px') !== -1) {
    return Number(fontSize.replace('px', ''));
  }
  return fontSize;
};

// 多层递归处理
export function flatByChildrenKey(trees: any[], childrenKey: string) {
  if (!trees?.length) return [];
  const result = [];
  for (const tree of trees) {
    result.push(tree);
    if (tree[childrenKey]?.length) {
      result.push(...flatByChildrenKey(tree[childrenKey], childrenKey));
    }
  }
  return result;
}

// 创建一个忽略指定keys的isEqual函数
export const createIsEqualWithIgnore = (ignoreKeys: string[]) => {
  return (a: any, b: any) => {
    if (!ignoreKeys || ignoreKeys.length === 0) {
      return isEqual(a, b);
    }
    const format = (data: any): any => {
      if (Array.isArray(data)) {
        return data.map((item) => format(item));
      }
      if (typeof data === 'object' && data !== null) {
        const result = omit(data, ignoreKeys);
        Object.keys(result).forEach((key) => {
          result[key] = format(result[key]);
        });
        return result;
      }
      return data;
    };
    return isEqual(format(a), format(b));
  };
};


// 对比两个数组或者对象之间的差异，并返回两个对象，两个对象的差异部分
export const getDiff = (a: any, b: any) => {
  const changes = (object: any, base: any) => {
    return transform(object, (result: any, value: any, key: any) => {
      const baseValue = base?.[key];
      if (!isEqual(value, baseValue)) {
        result[key] =
          isObject(value) && isObject(baseValue)
            ? changes(value, baseValue)
            : value;
      }
    });
  };
  return [changes(a, b), changes(b, a)];
};

export type Option = {
  name: string;
  value: string | number;
  children?: Option[];
  [key: string]: any;
}

// 查找并返回路径
export const findOptionPath = (options: Option[], targetValue: string | number, keyName: string = 'value'): Option[] | null => {
  for (const option of (options || [])) {
    if (option[keyName] === targetValue) {
      return [option];
    }
    
    if (option.children && option.children.length > 0) {
      const childPath = findOptionPath(option.children, targetValue, keyName);
      if (childPath) {
        return [option, ...childPath];
      }
    }
  }
  
  return null;
}

// 根据value查找选项
export function findOptionByValue(options: Option[], targetValue: string | number, keyName: string = 'value'): Option | null {
  for (const option of (options || [])) {
    // 直接匹配
    if (option[keyName] === targetValue) {
      return option;
    }
    
    // 递归查找子项
    if (option.children && option.children.length > 0) {
      const found = findOptionByValue(option.children, targetValue, keyName);
      if (found) {
        return found;
      }
    }
  }
  
  return null;
}